import { ElementSource } from "chq";

const trimSubtitles = (
  subtitleElements: ElementSource[],
  placement: { time: number; duration: number },
  currentElementId: string,
  trimFieldValue = false
): ElementSource[] => {
  const videoEndTime = placement.time + placement.duration;

  const remainingSubtitles = subtitleElements.filter((element: ElementSource) => {
    const elementEndTime = element.time + element.duration;
    const [_prefix, refId] = element.name.split("REF=", 2);

    if (refId !== currentElementId) return true;
    return !((elementEndTime <= placement.time) || (element.time >= videoEndTime));
  }).map((element: ElementSource) => {
    if (!trimFieldValue) return element;

    const [_prefix, refId] = element.name.split("REF=", 2);
    if (refId !== currentElementId) return element;

    // here we adjust the remaining subtitles of the current video element
    const newTime = Math.max(element.time - placement.time, 0);
    const oldEndTime = element.time + element.duration;
    return {
      ...element,
      time: newTime,
      duration: newTime === 0 ? oldEndTime - placement.time : element.duration
    };
  });

  return remainingSubtitles;
};

export default trimSubtitles;
